export const CHAT_ALLOWED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

export const CHAT_MAX_IMAGE_SIZE_MB = 2;

export const CHAT_MAX_IMAGE_SIZE_BYTES = CHAT_MAX_IMAGE_SIZE_MB * 1024 * 1024;
